import { Component, OnInit } from '@angular/core';
import { FiremessagingService } from 'src/app/services/firebase-messaging/firemessaging.service';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-tab-view',
  templateUrl: './tab-view.component.html',
  styleUrls: ['./tab-view.component.scss']
})
export class TabViewComponent implements OnInit {

  showProfileEditMode: boolean = false
  hideMenu: boolean;
  constructor(
    private authService: AuthService,
    private firebaseMessageService: FiremessagingService,
  ) {
    this.authService.hideNavigationMenuEventEmitter.subscribe(response => {
      this.hideMenu = response;
    })
  }

  ngOnInit(): void {
    this.firebaseMessageService.requestPermission();
    this.firebaseMessageService.receiveMessage();
  }
}
